var exports = {
  "TQ": "Checkbox.module__checkboxWrapper___cXBmeF",
  "r9": "Checkbox.module__disabled___cXBmeF",
  "iD": "Checkbox.module__menuDisabled___cXBmeF",
  "kv": "Checkbox.module__checkbox___cXBmeF",
  "aP": "Checkbox.module__box___cXBmeF",
  "LI": "Checkbox.module__round___cXBmeF",
  "KD": "Checkbox.module__checked___cXBmeF",
  "NX": "Checkbox.module__checkedInverted___cXBmeF",
  "e_": "Checkbox.module__inverted___cXBmeF",
  "oE": "Checkbox.module__checkIcon___cXBmeF",
  "HN": "Checkbox.module__invertedIcon___cXBmeF",
  "Pf": "Checkbox.module__label___cXBmeF",
  "hJ": "Checkbox.module__labelInteractive___cXBmeF",
  "QK": "Checkbox.module__labelText___cXBmeF",
  "GR": "Checkbox.module__keyboardShortcut___cXBmeF",
  "RA": "Checkbox.module__keyboardShortcutKey___cXBmeF",
  "wf": "Checkbox.module__keyboardShortcutLabel___cXBmeF",
  "xB": "Checkbox.module__keyboardShortcutHint___cXBmeF",
  "wP": "Checkbox.module__keyboardShortcutPortal___cXBmeF",
  "nV": "Checkbox.module__labelFocusRing___cXBmeF",
  "P8": "Checkbox.module__menuChecked___cXBmeF",
  "fb": "Checkbox.module__checkboxIndicator___cXBmeF",
};

module.exports = exports;
